import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"

import { Company } from "../_types"

const getPath = (id: number) => `/companies/${id}`

export const fetchGetCompanyById = defineFetcher((id: number): Promise<Company> => {
  return GET(getPath(id))
})
